// extracted by mini-css-extract-plugin
module.exports = {"gifts-button":"gifts-button__6z6zp"};